module.exports = __webpack_public_path__ + "336c4492c24ca9fe11cc19ff1ec0fa21.svg";